<script>
import ServiceTimeForm from '@views/reports/service-time-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    ServiceTimeForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    reportId: {
      required: true,
      default: null,
    },
    carUses: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(serviceTime) {
      this.setUnchanged();
      this.$emit('updated', serviceTime);
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.serviceTimeModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal ref="serviceTimeModal" v-model="showModal" size="lg" hide-footer :title="$t('titles.edit_service_time')" static @hide="hide" @hidden="$emit('hidden')">
    <ServiceTimeForm v-if="showModal" :report-id="reportId" :loaded-id="loadedId" :car-uses="carUses" @submitted="submit" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
